export const pageArray = (number) => {
	return [...Array(number + 1).keys()].slice(1);
	// this is a helper function for the Pagination Station
	// it creates an array of the total number of pages, so that we can map over it to display the pagination buttons.
};
